import "./AppointmentsAuthorizationToMedicalInformationFormViewEditComponent.scss";
import BackComponent from "../../../../shared/components/back/BackComponent";
import React, {useCallback, useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {CommonService} from "../../../../shared/services";
import CardComponent from "../../../../shared/components/card/CardComponent";
import ClientRegistrationAuthorizationToReleaseMedicalInformationComponent
    from "../../../client-registration-authorization-to-release-medical-information/ClientRegistrationAuthorizationToReleaseMedicalInformationComponent";
import LoaderComponent from "../../../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../../../shared/components/status-card/StatusCardComponent";

interface AppointmentsAuthorizationToMedicalInformationFormViewEditComponentProps {

}

const AppointmentsAuthorizationToMedicalInformationFormViewEditComponent = (props: AppointmentsAuthorizationToMedicalInformationFormViewEditComponentProps) => {
    const params = useParams<{ formId: string,appointmentId:string }>();
    const {formId,appointmentId} = params;
    const [authorizationToMedicalInformationDetails, setAuthorizationToMedicalInformationDetails] = React.useState<any[]>([]);
    const [authorizationToMedicalInformationDetailsLoading, setAuthorizationToMedicalInformationDetailsLoading] = React.useState<boolean>(false);
    const [authorizationToMedicalInformationDetailsLoadingFailed, setAuthorizationToMedicalInformationDetailsLoadingFailed] = React.useState<boolean>(false);
    const [authorizationToMedicalInformationDetailsLoaded, setAuthorizationToMedicalInformationDetailsLoaded] = React.useState<boolean>(false);
    const navigate = useNavigate();

    const getAuthorizationToMedicalInformationDetails = useCallback((formId: string) => {
        setAuthorizationToMedicalInformationDetailsLoading(true);
        setAuthorizationToMedicalInformationDetailsLoadingFailed(false);
        setAuthorizationToMedicalInformationDetailsLoaded(false);
        CommonService._appointment.getAuthorizationDetails(formId)
            .then((response: any) => {
                    setAuthorizationToMedicalInformationDetails(response.data);
                    setAuthorizationToMedicalInformationDetailsLoading(false);
                    setAuthorizationToMedicalInformationDetailsLoadingFailed(false);
                    setAuthorizationToMedicalInformationDetailsLoaded(true);
                }
            ).catch((error: any) => {
            setAuthorizationToMedicalInformationDetailsLoading(false);
            setAuthorizationToMedicalInformationDetailsLoadingFailed(true);
            setAuthorizationToMedicalInformationDetailsLoaded(false);
        })
    }, [])

    useEffect(() => {
        if (formId) {
            getAuthorizationToMedicalInformationDetails(formId);
        }
    }, [formId, getAuthorizationToMedicalInformationDetails]);
    const handleBackNavigation = useCallback(() => {
            navigate('/appointments/'+appointmentId)
    }, [navigate,appointmentId]);

    const handleSubmit = useCallback((values: any) => {
        setAuthorizationToMedicalInformationDetails(values);
    }, []);

    return (
        <div className={'appointments-authorization-to-medical-information-form-view-edit-component appointment-form'}>
            <div className={'appointments-view-edit-form-header'}>
                <BackComponent onClick={() => {
                    handleBackNavigation()
                }}/>
            </div>
            {
                authorizationToMedicalInformationDetailsLoading && <LoaderComponent/>
            }
            {
                authorizationToMedicalInformationDetailsLoadingFailed &&
                <StatusCardComponent title={'Failed to load form details'}/>
            }
            {
                authorizationToMedicalInformationDetailsLoaded &&
                <CardComponent>
                            <ClientRegistrationAuthorizationToReleaseMedicalInformationComponent
                                formId={formId}
                                initialValues={authorizationToMedicalInformationDetails}
                                onSubmitComplete={handleSubmit}
                                appointmentId={appointmentId}
                            />
                </CardComponent>
            }
        </div>
    );

};

export default AppointmentsAuthorizationToMedicalInformationFormViewEditComponent;
